import { createHmac, timingSafeEqual } from "node:crypto";
export function parseBody(reqBody) {
    const { paymentIntentId, expiration } = typeof reqBody === "string" ? JSON.parse(reqBody) : reqBody;
    if (typeof paymentIntentId !== "string") {
        throw new Error(`paymentIntentId: Expected string but got ${typeof expiration}.`);
    }
    if (typeof expiration !== "number") {
        throw new Error(`expiration: Expected number but got ${typeof expiration}.`);
    }
    return {
        payload: typeof reqBody === "string"
            ? reqBody
            : JSON.stringify({ paymentIntentId, expiration }),
        paymentIntentId,
        expiration,
    };
}
export function parseHeaders(headers) {
    if (!("x-crablr-hmac-sha256" in headers)) {
        throw new Error("x-crablr-hmac-sha256 header: Missing value");
    }
    if (typeof headers["x-crablr-hmac-sha256"] !== "string") {
        throw new Error(`x-crablr-hmac-sha256 header: Expected string but got ${typeof headers["x-crablr-hmac-sha256"]}.`);
    }
    return headers["x-crablr-hmac-sha256"];
}
export function parseReq(req) {
    return {
        body: parseBody(req.body),
        receivedSignature: parseHeaders(req.headers),
    };
}
export const assertSignature = (webhookSecret) => {
    return ({ paymentIntentId, expiration }, crablrSignatureValue) => {
        if (expiration < new Date().getTime() / 1000) {
            throw new Error("Signature is expired.");
        }
        const hmac = createHmac("sha256", webhookSecret);
        hmac.update(JSON.stringify({
            paymentIntentId,
            expiration,
        }), "utf8");
        if (!timingSafeEqual(hmac.digest(), Buffer.from(crablrSignatureValue, "hex"))) {
            throw new Error("Invalid signature.");
        }
        return paymentIntentId;
    };
};
export function createWebhook(options) {
    return {
        assertSignature: assertSignature(options.webhookSecret),
    };
}
